module.exports = __webpack_public_path__ + "static/media/galeria-fotos-3.92dcb85c.png";